import type { AITTokens, AITPrimitiveTokens, AITTokens as Tokens } from './tokens';
import {
  createSemanticTokens,
  primitiveTokens as basePrimitiveTokens,
  getSpacingFromToken,
  getRadiusFromToken
} from './tokens';
import { createColors } from './tokens/primitive-tokens/colors';

const createThemeUtils = (tokens: Tokens) => {
  return {
    getSpacing: (level: number) => getSpacingFromToken(tokens, level),
    getRadius: (boxSize: number) => getRadiusFromToken(tokens, boxSize)
  };
};

export type AITThemeUtils = ReturnType<typeof createThemeUtils>;
export type AITBaseTheme = {
  tokens: AITTokens;
  primitiveTokens: AITPrimitiveTokens;
  utils: AITThemeUtils;
  // 旅工房対応でButtonとLinkだけthemeからoverride可にする
  overrides?: Record<'Button' | 'Link', any>;
};
export type AITTheme = AITBaseTheme & Record<string, any>;

export const createAITTheme = ({
  tokens: overrideTokens,
  primitiveTokens: overridePrimitiveTokens,
  serviceId = 1, // デフォルトはAITravel
  ...args
}: Partial<Omit<AITTheme, 'utils'>> & { serviceId?: number } = {}): AITTheme => {
  // serviceIdに基づいて色を取得
  const colors = createColors(serviceId);

  // primitiveTokensにserviceId固有の色を適用
  const primitiveTokensWithColors = {
    ...basePrimitiveTokens,
    colors,
    ...overridePrimitiveTokens
  };

  const semanticTokens = createSemanticTokens(serviceId);
  const tokens: AITTokens = { ...semanticTokens, ...overrideTokens };
  const primitiveTokens: AITPrimitiveTokens = primitiveTokensWithColors;
  const utils: AITThemeUtils = createThemeUtils(tokens);

  return { tokens, primitiveTokens, utils, ...args };
};
